<template>
  <div class="page">
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="portfolio-shell">
            <div class="text-center mb-4">
              <p class="eyebrow">Selected work</p>
              <h1>Projects that balance design, clarity, and performance.</h1>
              <p class="lead">
                These sites reflect a mix of professional branding, storytelling, and clean user experience.
              </p>
            </div>

            <div class="row">
              <div class="col-md-6 mb-4" v-for="project in projects" :key="project.name">
                <div class="project-card">
                  <h3>{{ project.name }}</h3>
                  <p>{{ project.description }}</p>
                  <a :href="project.url" target="_blank" rel="noopener noreferrer">Visit site</a>
                </div>
              </div>
            </div>

            <div class="cta-card">
              <h3>Ready to create something similar?</h3>
              <p>Let’s turn your next website into a polished, high-converting experience.</p>
              <router-link to="/Contact" class="btn btn-primary">Start a Conversation</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Portfolio",
  data() {
    return {
      projects: [
        {
          name: "American Energy Consulting",
          description: "A professional consulting website focused on trust, clarity, and authority.",
          url: "http://www.AmericanEnergyConsulting.com",
        },
        {
          name: "Artist ERJ",
          description: "A streamlined portfolio experience for an artistic brand and personal identity.",
          url: "http://www.Artist-ERJ.com",
        },
        {
          name: "Chicago Artwork",
          description: "A refined site designed to showcase artistic work with a strong visual presentation.",
          url: "http://www.Chicago-Artwork.com",
        },
        {
          name: "Chicago River Paddle",
          description: "A clear and inviting website that makes outdoor experiences easy to discover.",
          url: "http://www.ChicagoRiverPaddle.com",
        },
        {
          name: "Eric Johnson Resume",
          description: "A polished personal brand page built with professional structure and readability.",
          url: "http://www.EricJohnsonResume.com",
        },
        {
          name: "IMEJ Tech",
          description: "A modern service website with a professional layout and clear conversion path.",
          url: "http://www.ImejTech.com",
        },
      ],
    };
  },
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background-image: url("../assets/screen-5.png");
  background-size: cover;
  background-position: center;
  animation: backgroundMove 120s ease-in-out infinite;
}
.portfolio-shell {
  background: rgba(7, 17, 31, 0.9);
  border-radius: 18px;
  padding: 36px;
  color: white;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.25);
}
.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.8rem;
  color: #c5d4ff;
  margin-bottom: 8px;
}
h1 {
  font-size: 2rem;
  margin-bottom: 12px;
}
.lead {
  color: #dde7ff;
  margin-bottom: 24px;
}
.project-card,
.cta-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  padding: 20px;
  height: 100%;
}
.project-card h3 {
  font-size: 1.1rem;
  margin-bottom: 8px;
}
.project-card p,
.cta-card p {
  color: #e4ecff;
  line-height: 1.7;
}
.project-card a {
  color: #7dd3fc;
  font-weight: 600;
}
.cta-card {
  margin-top: 12px;
}
@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
